import script from "./ImportSoAmodel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportSoAmodel.vue?vue&type=script&setup=true&lang=js"

import "./ImportSoAmodel.vue?vue&type=style&index=0&id=2890c9fb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2890c9fb"]])

export default __exports__